// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d48dd9fb","455":"255c419f","977":"2d6c9e63"}[chunkId] + ".chunk.js";
};